._AnnualRelative_1te5r_1 {
  text-align: right;
}